import { FETCH_CLIENT_NUDGE_FAILURE, FETCH_CLIENT_NUDGE_REQUEST, FETCH_CLIENT_NUDGE_SUCCESS } from "../actions/clientNudgeActions";

  const initialState = {
    response: [],
    loading: true,
    error: null,
  };
  
  const clientNudgeReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CLIENT_NUDGE_REQUEST:
        return { ...state, loading: true , payload: action.payload};
      case FETCH_CLIENT_NUDGE_SUCCESS:
        return { ...state, loading: false, response: action.payload };
      case FETCH_CLIENT_NUDGE_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default clientNudgeReducer;
  